(function () {
  var locatorSelector = '[data-st-store-locator]';
  var mapDefaults = {
    center: [50.7, 10.4],
    zoom: 6
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function toTelHref(phone) {
    var digits = String(phone || '').replace(/[^\d+]/g, '');
    return digits ? 'tel:' + digits : '';
  }

  function distanceKm(from, to) {
    var radius = 6371;
    var lat1 = from.lat * Math.PI / 180;
    var lat2 = to.lat * Math.PI / 180;
    var deltaLat = (to.lat - from.lat) * Math.PI / 180;
    var deltaLng = (to.lng - from.lng) * Math.PI / 180;
    var a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) *
      Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
    return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatDistance(km) {
    if (typeof km !== 'number' || Number.isNaN(km)) return '';
    return km < 10 ? km.toFixed(1) + ' km' : Math.round(km) + ' km';
  }

  function waitForLeaflet(callback, attempts) {
    if (window.L) {
      callback();
      return;
    }
    if ((attempts || 0) > 80) return;
    window.setTimeout(function () {
      waitForLeaflet(callback, (attempts || 0) + 1);
    }, 50);
  }

  function geocodePostalCode(postalCode) {
    var params = new URLSearchParams({
      format: 'jsonv2',
      countrycodes: 'de,at',
      postalcode: postalCode,
      limit: '1'
    });

    return fetch('https://nominatim.openstreetmap.org/search?' + params.toString(), {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Postal lookup failed');
        return response.json();
      })
      .then(function (items) {
        if (!items || !items.length) return null;
        return {
          lat: Number(items[0].lat),
          lng: Number(items[0].lon)
        };
      })
      .catch(function () {
        return null;
      });
  }

  function buildSearchIndex(location) {
    return normalize([
      location.name,
      location.therapist,
      location.address,
      location.postalCode,
      location.region,
      location.country
    ].filter(Boolean).join(' '));
  }

  function popupHtml(location) {
    var rows = [
      '<strong>' + escapeHtml(location.name) + '</strong>',
      location.therapist ? '<span>' + escapeHtml(location.therapist) + '</span>' : '',
      '<span>' + escapeHtml(location.address) + '</span>',
      location.phone ? '<a href="' + escapeHtml(toTelHref(location.phone)) + '">' + escapeHtml(location.phone) + '</a>' : '',
      location.email ? '<a href="mailto:' + escapeHtml(location.email) + '">' + escapeHtml(location.email) + '</a>' : '',
      location.website ? '<a href="' + escapeHtml(location.website) + '" target="_blank" rel="noopener noreferrer">Website</a>' : ''
    ].filter(Boolean);

    return '<div class="st-store-locator__popup">' + rows.join('') + '</div>';
  }

  function statusColor(location) {
    return location.certified === false ? '#2c6337' : '#7a47b5';
  }

  function cardHtml(location, index) {
    var distance = formatDistance(location.distanceKm);
    var statusClass = location.certified === false ? 'st-store-locator__card--non-certified' : 'st-store-locator__card--certified';
    var markerColor = statusColor(location);
    var contact = [
      location.phone ? '<a href="' + escapeHtml(toTelHref(location.phone)) + '">' + escapeHtml(location.phone) + '</a>' : '',
      location.email ? '<a href="mailto:' + escapeHtml(location.email) + '">' + escapeHtml(location.email) + '</a>' : '',
      location.website ? '<a href="' + escapeHtml(location.website) + '" target="_blank" rel="noopener noreferrer">Website</a>' : ''
    ].filter(Boolean);

    return [
      '<button class="st-store-locator__card ' + statusClass + '" type="button" data-locator-card="' + escapeHtml(location.id) + '">',
      '<span class="st-store-locator__card-index" style="background-color:' + markerColor + '" aria-hidden="true"></span>',
      '<span class="st-store-locator__card-body">',
      '<span class="st-store-locator__card-name">' + escapeHtml(location.name) + '</span>',
      location.therapist ? '<span class="st-store-locator__card-meta">' + escapeHtml(location.therapist) + '</span>' : '',
      '<span class="st-store-locator__card-address">' + escapeHtml(location.address) + '</span>',
      distance ? '<span class="st-store-locator__card-distance">' + escapeHtml(distance) + '</span>' : '',
      contact.length ? '<span class="st-store-locator__card-links">' + contact.join('') + '</span>' : '',
      '</span>',
      '</button>'
    ].join('');
  }

  function initLocator(root) {
    if (root.__stLocatorReady) return;
    root.__stLocatorReady = true;

    var mapElement = root.querySelector('[data-locator-map]');
    var listElement = root.querySelector('[data-locator-list]');
    var countElement = root.querySelector('[data-locator-count]');
    var statusElement = root.querySelector('[data-locator-status]');
    var input = root.querySelector('[data-locator-input]');
    var form = root.querySelector('[data-locator-search]');
    var clearButton = root.querySelector('[data-locator-clear]');
    var geoButton = root.querySelector('[data-locator-geolocation]');
    var labels = {
      nearest: root.dataset.nearestLabel || 'Nearest matches',
      count: root.dataset.countLabel || 'locations',
      singular: root.dataset.countLabelSingular || 'location',
      none: root.dataset.noResults || 'No practices found for this search.',
      loading: root.dataset.loadingLabel || 'Loading locations...'
    };
    var map;
    var markerLayer;
    var markersById = {};
    var locations = [];
    var isMobileViewport = window.matchMedia('(max-width: 749px)').matches;

    function setStatus(message) {
      if (!statusElement) return;
      statusElement.hidden = !message;
      statusElement.textContent = message || '';
    }

    function setCount(count) {
      var suffix = count === 1 ? labels.singular : labels.count;
      countElement.textContent = count + ' ' + suffix;
    }

    function fitLocations(items) {
      if (!items.length) return;
      if (items.length === 1) {
        map.setView([items[0].lat, items[0].lng], 13);
        return;
      }
      var bounds = window.L.latLngBounds(items.map(function (item) {
        return [item.lat, item.lng];
      }));
      map.fitBounds(bounds, {
        padding: [34, 34],
        maxZoom: 11
      });
    }

    function render(items, options) {
      var visible = items.slice(0, options && options.limit ? options.limit : items.length);
      markersById = {};
      markerLayer.clearLayers();
      visible.forEach(function (location, index) {
        var markerStatusClass = location.certified === false ? 'st-store-locator__marker--non-certified' : 'st-store-locator__marker--certified';
        var markerColor = statusColor(location);
        var marker = window.L.marker([location.lat, location.lng], {
          title: location.name,
          icon: window.L.divIcon({
            className: 'st-store-locator__marker ' + markerStatusClass,
            html: '<span style="background-color:' + markerColor + '" aria-hidden="true"></span>',
            iconSize: [17, 17],
            iconAnchor: [8.5, 8.5],
            popupAnchor: [0, -10]
          })
        }).bindPopup(popupHtml(location));
        markersById[location.id] = marker;
        markerLayer.addLayer(marker);
      });

      listElement.innerHTML = visible.length
        ? visible.map(cardHtml).join('')
        : '<p class="st-store-locator__empty">' + escapeHtml(labels.none) + '</p>';
      setCount(visible.length);
      setStatus(options && options.status ? options.status : '');
      fitLocations(visible.length ? visible : locations);
    }

    function sortByDistance(origin, items) {
      return items.map(function (item) {
        return Object.assign({}, item, {
          distanceKm: distanceKm(origin, item)
        });
      }).sort(function (a, b) {
        return a.distanceKm - b.distanceKm;
      });
    }

    function postalFallback(postalCode) {
      var exact = locations.filter(function (item) {
        return item.postalCode === postalCode;
      });
      if (exact.length) return { items: exact, status: '' };

      var prefix = postalCode.slice(0, 2);
      var prefixMatches = locations.filter(function (item) {
        return item.postalCode && item.postalCode.slice(0, 2) === prefix;
      });
      if (prefixMatches.length) {
        return {
          items: prefixMatches,
          status: labels.nearest
        };
      }

      return {
        items: locations.slice().sort(function (a, b) {
          return Math.abs(Number(a.postalCode) - Number(postalCode)) - Math.abs(Number(b.postalCode) - Number(postalCode));
        }).slice(0, 8),
        status: labels.nearest
      };
    }

    function search(query) {
      var value = query.trim();
      if (!value) {
        render(locations);
        return;
      }

      var postalMatch = value.match(/^\d{4,5}$/);
      if (postalMatch) {
        var fallback = postalFallback(value);
        render(fallback.items, {
          status: fallback.status,
          limit: fallback.status ? 8 : undefined
        });

        if (!fallback.items.length || fallback.status) {
          setStatus(labels.nearest);
          geocodePostalCode(value).then(function (origin) {
            if (!origin) return;
            render(sortByDistance(origin, locations), {
              status: labels.nearest,
              limit: 8
            });
          });
        }
        return;
      }

      var normalized = normalize(value);
      var matches = locations.filter(function (item) {
        return item.searchIndex.indexOf(normalized) !== -1;
      });
      render(matches);
    }

    function load() {
      fetch(root.dataset.locationsUrl, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Location data failed');
          return response.json();
        })
        .then(function (payload) {
          locations = (payload.locations || []).map(function (location) {
            return Object.assign({}, location, {
              searchIndex: buildSearchIndex(location)
            });
          });
          render(locations);
        })
        .catch(function () {
          listElement.innerHTML = '<p class="st-store-locator__empty">' + escapeHtml(labels.none) + '</p>';
          countElement.textContent = labels.loading;
        });
    }

    map = window.L.map(mapElement, {
      dragging: !isMobileViewport,
      scrollWheelZoom: false,
      tap: !isMobileViewport,
      touchZoom: !isMobileViewport
    }).setView(mapDefaults.center, mapDefaults.zoom);

    if (isMobileViewport) {
      if (map.dragging) map.dragging.disable();
      if (map.touchZoom) map.touchZoom.disable();
      if (map.tap) map.tap.disable();
      mapElement.addEventListener('wheel', function (event) {
        event.stopImmediatePropagation();
      }, { capture: true, passive: true });
      mapElement.addEventListener('touchmove', function (event) {
        event.stopImmediatePropagation();
      }, { capture: true, passive: true });
    }

    window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    markerLayer = window.L.layerGroup().addTo(map);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      search(input.value);
    });

    input.addEventListener('input', function () {
      if (!input.value.trim()) render(locations);
    });

    clearButton.addEventListener('click', function () {
      input.value = '';
      render(locations);
      input.focus();
    });

    geoButton.addEventListener('click', function () {
      if (!navigator.geolocation) return;
      setStatus(labels.nearest);
      navigator.geolocation.getCurrentPosition(function (position) {
        render(sortByDistance({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }, locations), {
          status: labels.nearest,
          limit: 8
        });
      });
    });

    listElement.addEventListener('click', function (event) {
      var card = event.target.closest('[data-locator-card]');
      if (!card) return;
      var marker = markersById[card.dataset.locatorCard];
      if (!marker) return;
      map.setView(marker.getLatLng(), 13);
      marker.openPopup();
    });

    load();
  }

  function initAll() {
    waitForLeaflet(function () {
      document.querySelectorAll(locatorSelector).forEach(initLocator);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
